<template>
  <!-- KP-4621: a collection this retailer can't see answers like one that doesn't exist.
       Nothing about it (name, image, description) is shown. -->
  <v2-card
    class="v2-collection-products-page__empty"
    :data-testid="forRetailerView ? 'collection-unavailable-for-retailer' : 'collection-unavailable'"
  >
    <h3 class="v2-heading-sm v2-mb-2">
      {{ forRetailerView ? 'Not available to this retailer' : 'Collection not available' }}
    </h3>
    <p
      class="v2-text-sm v2-text-muted"
      :class="{ 'v2-mb-4': !forRetailerView }"
    >
      {{ forRetailerView
        ? "This retailer can't see this collection. Their segmentation may hide every product in it, or the collection no longer exists."
        : "This collection doesn't exist or isn't available to you." }}
    </p>
    <v2-button
      v-if="!forRetailerView"
      variant="primary"
      @click="$emit('back')"
    >
      {{ backLabel }}
    </v2-button>
  </v2-card>
</template>

<script>
import V2Card from '@/components/v2/V2Card.vue'
import V2Button from '@/components/v2/V2Button.vue'

// KP-4621: shown when the catalog answers "Collection not found" for the collection (an
// unknown collection, or one the retailer's segmentation hides completely). For a retailer
// it replaces the page; for a brand it sits in the product area, so the toolbar and the
// retailer picker stay. "Back" goes to a fixed page (the parent decides which), because a
// collection opened from a link may have no history to go back to.
export default {
  name: 'V2CollectionUnavailable',
  components: { V2Card, V2Button },
  props: {
    forRetailerView: {
      type: Boolean,
      default: false,
    },
    backLabel: {
      type: String,
      default: 'Back to Collections',
    },
  },
  emits: ['back'],
}
</script>
